import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './guest.reducer';

export const GuestDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const guestEntity = useAppSelector(state => state.guest.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="guestDetailsHeading">
          <Translate contentKey="fivePlusApp.guest.detail.title">Guest</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{guestEntity.id}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="fivePlusApp.guest.status">Status</Translate>
            </span>
          </dt>
          <dd>{guestEntity.status ? 'true' : 'false'}</dd>
          <dt>
            <span id="dailyCoGuestLink">
              <Translate contentKey="fivePlusApp.guest.dailyCoGuestLink">Daily Co Guest Link</Translate>
            </span>
          </dt>
          <dd>{guestEntity.dailyCoGuestLink}</dd>
          <dt>
            <Translate contentKey="fivePlusApp.guest.user">User</Translate>
          </dt>
          <dd>{guestEntity.user ? guestEntity.user.id : ''}</dd>
          <dt>
            <Translate contentKey="fivePlusApp.guest.meeting">Meeting</Translate>
          </dt>
          <dd>{guestEntity.meeting ? guestEntity.meeting.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/guest" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/guest/${guestEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default GuestDetail;
